export class LoggingAnalyticsHandler {
  trackPageView(url) {
    console.log('Analytics page view:', url);
  }
}

// Google Analytics 4 (GA4) using gtag.js script, which is included in util/includeScripts.js
export class GoogleAnalyticsHandler {
  trackPageView(canonicalPath, previousPath) {
    // GA4 property. We send EVERY page_view manually from the SPA:
    // https://developers.google.com/analytics/devguides/collection/gtagjs/single-page-applications
    //
    // Design (see docs/design/analytics-title-and-pageview-consistency.md):
    // - Note 1: "Enhanced measurement" must be OFF in the GA4 property, or
    //   it attaches its own history listener and double-counts every SPA
    //   navigation. (Owner-disabled 2026-07-08.)
    // - Note 2: gtag's automatic initial page_view is disabled
    //   (send_page_view:false in includeScripts.js), so we fire the FIRST
    //   page_view too. That is why there is no `previousPath` guard here:
    //   previousPath is null on the initial load and set on in-app nav —
    //   both must fire, exactly once each.
    // - Note 3: the timeout lets document.title update (the location
    //   change is dispatched before the new page renders its <title>).
    // - We send a slug-stripped canonical page_path + a matching
    //   page_location + page_title so a listing is reported under one
    //   consistent path (/l/{id}) whether it was hard-loaded at
    //   /l/{slug}/{id} or reached via in-app navigation.
    if (window.gtag) {
      window.setTimeout(() => {
        const origin = typeof window !== 'undefined' ? window.location.origin : '';
        window.gtag('event', 'page_view', {
          page_path: canonicalPath,
          page_location: `${origin}${canonicalPath}`,
          page_title: typeof document !== 'undefined' ? document.title : undefined,
        });
      }, 300);
    }
  }
}
